import { useEffect, useRef } from "react";

/**
 * PhoneInput shows a fixed dial code prefix and lets the user type the rest.
 * The value passed up always starts with the dial code.
 */
export default function PhoneInput({
  value,
  onChange,
  dialCode,
  placeholder = "",
  "data-testid": testId,
  required = false,
  error = "",
  hint = "",
}) {
  const inputRef = useRef(null);

  // Ensure value always starts with current dialCode
  useEffect(() => {
    if (!dialCode) return;
    if (!value || !value.startsWith(dialCode)) {
      onChange(dialCode + (value && value.startsWith("+") ? "" : (value || "").replace(/^\+\d{1,4}\s?/, "")));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dialCode]);

  const localPart = value && value.startsWith(dialCode) ? value.slice(dialCode.length).replace(/^\s+/, "") : (value || "");

  const handleChange = (e) => {
    const raw = e.target.value.replace(/^\s+/, "");
    onChange(dialCode + (raw ? " " + raw : ""));
  };

  const borderColor = error ? "#DC2626" : "var(--sl-border)";
  const ringClass = error
    ? "focus-within:border-red-500 focus-within:ring-red-500/15"
    : "focus-within:border-[var(--sl-primary)] focus-within:ring-[var(--sl-primary)]/15";

  return (
    <div>
      <div
        className={`flex items-stretch rounded-lg border bg-white overflow-hidden focus-within:ring-2 transition ${ringClass}`}
        style={{ borderColor }}
      >
        <div
          className="px-3 flex items-center bg-[var(--sl-bg-alt)] border-r font-mono text-sm font-semibold text-gray-700"
          style={{ borderColor }}
        >
          {dialCode}
        </div>
        <input
          ref={inputRef}
          type="tel"
          value={localPart}
          onChange={handleChange}
          placeholder={placeholder}
          className="flex-1 px-4 py-3 outline-none text-gray-900 placeholder-gray-400"
          data-testid={testId}
          required={required}
          inputMode="numeric"
        />
      </div>
      {error ? (
        <div className="mt-1 text-xs text-red-600" data-testid={`${testId}-error`}>{error}</div>
      ) : hint ? (
        <div className="mt-1 text-xs text-gray-500">{hint}</div>
      ) : null}
    </div>
  );
}
